var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 14,
    viewBox: "0 0 12 14",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m5.35307 1.17745c.4242-.11151.86962-.11151 1.29382 0 .98955.26013 1.69746 1.12499 1.77605 2.14045l-.02931-.00626c-1.57826-.33732-3.209-.33732-4.78725 0l-.02936.00627c.07858-1.01547.7865-1.88033 1.77605-2.14046zm4.16069 2.32907v.16335c1.10564.53036 1.94384 1.53225 2.25994 2.76029.3729 1.4485.2832 2.97888-.2565 4.37284l-.0633.1637c-.5789 1.4953-1.89692 2.5708-3.46656 2.8288l-.51085.084c-.9779.1607-1.97511.1607-2.953 0l-.51084-.084c-1.56965-.258-2.88766-1.3335-3.466517-2.8288l-.063375-.1637c-.5396333-1.39397-.629402-2.92434-.2565-4.37283.316146-1.22804 1.154332-2.22991 2.259942-2.76028v-.16337c0-1.59355 1.06618-2.985998 2.59381-3.387583.60325-.1585826 1.23668-.1585827 1.83994 0 1.52763.401586 2.59381 1.794033 2.59381 3.387583zm-3.51375 4.15489c.23937 0 .43342.19588.43342.43752v1.45842c0 .24164-.19405.43753-.43342.43753s-.43342-.19589-.43342-.43753v-1.45842c0-.24164.19405-.43752.43342-.43752z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.3f1edc2356af8d4f2feb52b8e035760c.svg";
export { ForwardRef as ReactComponent };